"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ui = require("@unite-us/ui");
var _lodash = require("lodash");
var _languageEnums = _interopRequireDefault(require("../../utils/enums/languageEnums"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var LanguageSelector = function LanguageSelector(_ref) {
  var _onChange = _ref.onChange,
    field = _ref.field,
    registerField = _ref.registerField,
    disabled = _ref.disabled,
    theme = _ref.theme,
    options = _ref.options,
    appContext = _ref.appContext,
    translationsNewLanguageFlag = _ref.translationsNewLanguageFlag;
  var languageOptions;
  switch (appContext) {
    case 'shares':
      languageOptions = _languageEnums["default"].languages.filter(function (language) {
        return language.shares;
      });
      break;
    case 'widgets':
      languageOptions = _languageEnums["default"].languages.filter(function (language) {
        return language.widgets;
      });
      break;
    case 'consent':
    default:
      languageOptions = translationsNewLanguageFlag ? _languageEnums["default"].languages.filter(function (language) {
        return language.consent;
      }) : _languageEnums["default"].languages.filter(function (language) {
        return language.consent && !language["new"];
      });
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: theme,
    className: "flex items-center space-x-2 space-y-2 h-8"
  }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
    className: "-mt-2",
    icon: "IconGlobe"
  }), /*#__PURE__*/_react["default"].createElement(_ui.SelectField, {
    className: "language-select-field",
    id: "language-selector",
    field: field,
    registerField: registerField,
    clearable: false,
    label: "Language:",
    options: !(0, _lodash.isEmpty)(options) ? options : languageOptions,
    onChange: function onChange(language) {
      return _onChange(language, field, registerField);
    },
    labelKey: "display_name",
    valueKey: "value",
    labelClassName: "language-select-field-label normal-case text-sm -mt-1",
    inline: true,
    disabled: disabled
  }));
};
LanguageSelector.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  field: _propTypes["default"].object,
  registerField: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  theme: _propTypes["default"].object,
  options: _propTypes["default"].array,
  appContext: _propTypes["default"].string,
  translationsNewLanguageFlag: _propTypes["default"].bool
};
LanguageSelector.defaultProps = {
  field: {
    name: 'language',
    initialValue: 'en',
    value: 'en'
  },
  registerField: null,
  disabled: false,
  theme: {
    width: '20rem'
  },
  options: [],
  appContext: '',
  translationsNewLanguageFlag: false
};
var _default = exports["default"] = LanguageSelector;